import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMC_VIEW_OPTIONS } from './cmcCommandOptions';
import { CMD_CMCUSAGE_REGISTRY_KEY, META_TYPE, META_VER } from './cmcUsageCommandRegisteryType';

/**
 * Registers the /cmc command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /cmc <view> — opens a cmc card by view name, e.g. /cmc usage.
 * Only 'usage' is wired for now — more views (e.g. feargreed) get added to
 * CMC_VIEW_OPTIONS + the switch below as they're folded into this command.
 */
export function registerCmcCommand() {
    commandEngine.register('/cmc', {
        hint: 'Open cmc widget',
        params: [{ name: 'view', options: CMC_VIEW_OPTIONS }],
        handler: ([view]) => {
            switch (view) {
                case 'usage':
                default:
                    cardPainterManager.openCard(CMD_CMCUSAGE_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
                    break;
            }
        },
    });
}
